var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-nowrap"},[_c('svg-icon',{attrs:{"icon":"calendar"}}),(_vm.end)?_c('span',[_vm._v(_vm._s(_vm.startDate)+" - "+_vm._s(_vm.endDate))]):_c('span',[_vm._v(_vm._s(_vm.startDate))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }